<c11n-step-indicator [stepAlign]="'start'" [stepLabelDisplay]="isSmallScreen?'none':'all'" [stepLabels]="stepLabels"
                     [currentStep]="currentStep">
</c11n-step-indicator>

  <div class="mt-1 d-block d-sm-none">
    <c11n-details variant="secondary" expandLabelText="View steps" collapseLabelText="View steps"
                  iconPosition="trailing" [labelAlign]="'left'">
      <ol class="c11n-expandable-list">
        <li
          *ngFor="let step of stepLabels; index as i"
          [attr.aria-current]="i + 1 === currentStep ? 'step' : null"
        >
          {{ step }}
        </li>
      </ol>
    </c11n-details>
  </div>
